export const cleanTitle = () => platformEntity => {
  if (platformEntity.platform === 'consumer') {
    return I18n.t('js.creators.consumer_reviews')
  }
  return platformEntity.title
}
